module.exports = __webpack_public_path__ + "static/anthony-9af14eb7eda2f5b4eb3c813f3d445754.png";